import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-arr-sort',
  templateUrl: './arr-sort.component.html',
  styleUrls: ['./arr-sort.component.css']
})
export class ArrSortComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
